import { render, staticRenderFns } from "./BetgameFAQ.vue?vue&type=template&id=db89bd1a&scoped=true"
import script from "./BetgameFAQ.vue?vue&type=script&lang=js"
export * from "./BetgameFAQ.vue?vue&type=script&lang=js"
import style0 from "./BetgameFAQ.vue?vue&type=style&index=0&id=db89bd1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db89bd1a",
  null
  
)

export default component.exports